import { logClientError } from 'src/util/server-log';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { AssetUrlDirective } from "./directives/asset-url.directive";
import { currentVersion } from "../environments/version";
import { ModalAlertComponent } from "./components/modal-alert/modal-alert.component";
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { PhoneRequiredModalComponent } from "./components/phone-required-modal/phone-required-modal.component";
import { SharedService } from "./services/shared/shared.service";
import { GrpcSubscriptionService } from "./services/grpc-subscription/grpc-subscription.service";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-root",
    imports: [RouterOutlet, AssetUrlDirective, ModalAlertComponent, ToastContainerComponent, PhoneRequiredModalComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
  standalone: true,
})
export class AppComponent implements OnInit {
  title = "svm-web";
  updatedVersion: string = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private grpcSubscriptionService: GrpcSubscriptionService,
  ) {
    this.updatedVersion = currentVersion.buildTime;
  }

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.activatedRoute.queryParams);
    const planId = params["plan_id"];
    if (planId) {
      this.sharedService.setPlanId(planId);
      try {
        const plan = await this.grpcSubscriptionService.getPlanById(planId);
        this.sharedService.currentPlan = plan.toObject().plan;
      } catch (error) {
        logClientError("Error fetching plan:", error);
      }
    }
  }
}
